import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'caseStatusPipe'
})
export class CaseStatusPipe implements PipeTransform {

  transform(value: string|null): string {
    switch(value) {
      case 'started': return 'Yürüyen';
      case 'canceled': return 'İptal';
      case 'finished': return 'Tamamlandı';
      case 'progressCanceled': return 'İşlem İptal';
      default:return "" // 23 Temmuz 18:50 Musa Aslan Belirsiz yazısını görmek istemediğini iletti 
    }
  }

}
